// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__14jVj","buttons":"RemoveExpirationActionButtons_buttons__2w_Eo"};